import React, { useEffect } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { loginUser } from "../loginSlice";
import "./login.css";
import ModakBackdrop from "../modak/ModakBackdrop";
import { setBackButtonUrl } from "../uiSlice";
import Swal from "sweetalert2";

function Login() {
  const dispatch = useDispatch();
  const { status, user, error } = useSelector((state) => state.auth);

  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const isAdmin = searchParams.get("admin") === "true";

  useEffect(() => {
    dispatch(loginUser());
  }, [dispatch]);

  useEffect(() => {
    if (status === "succeeded" && user && isAdmin) {
      navigate("/admin");
    }
  }, [status, user, isAdmin, navigate]);

  useEffect(() => {
    if (status === "succeeded" && user?.backButtonRedirect) {
      dispatch(setBackButtonUrl(user.backButtonRedirect));
    }
  }, [status, user, dispatch]);



 useEffect(() => {
  if (status !== "failed") return;
  const msg = error ? String(error) : "Session expired";
  const redirect = user && user.backButtonRedirect ? user.backButtonRedirect : "/";
  Swal.fire("Session Expired!", msg, "error").then(() => {
    window.location.href = redirect;
  });
}, [status, error, user]);

// result.status = completed → Already Played. status = playing → resume.
useEffect(() => {
  if (isAdmin) return;
  if (status !== "succeeded" || !user) return;
  const playStatus = String(user.status || "").toLowerCase();
  const isCompleted =
    playStatus === "completed" || Number(user.gameover ?? 0) > 0;
  if (isCompleted) {
    Swal.fire("Already Played", "You have already completed this game.", "info").then(() => {
      window.location.href = process.env.REACT_APP_BASE_URL || "/";
    });
  }
}, [status, user, isAdmin]);

  if (status === "loading") {
    return (
      <div className="login-main-container">
        <div className="quiz-loader-container">
          <div className="quiz-loader"></div>
        </div>
      </div>
    );
  }

  return (
    <ModakBackdrop center>
      <div className="modak-login">
        <img src="/modak-assets/person1.png" className="modak-login-person" alt="" />

        <div className="modak-login-center">
          <img src="/modak-assets/modak.gif" className="modak-login-mascot" alt="Modak Marathon" />

          {user &&
            status === "succeeded" &&
            String(user.status || "").toLowerCase() !== "completed" &&
            Number(user.gameover ?? 0) === 0 && (
            <Link to="/rules" className="modak-btn modak-begin-btn">
              BEGIN PLAY
              <svg className="modak-arrow" viewBox="0 0 66 43" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M40.15 3.9 43.98.14a.5.5 0 0 1 .7 0l21 20.65a1 1 0 0 1 0 1.4l-21 20.66a.5.5 0 0 1-.7 0l-3.83-3.75a.5.5 0 0 1 0-.71L56.99 21.86a.5.5 0 0 0 0-.72L40.15 4.6a.5.5 0 0 1 0-.7z"
                  fill="#fff"
                />
                <path
                  d="M20.15 3.9 23.98.14a.5.5 0 0 1 .7 0l21 20.65a1 1 0 0 1 0 1.4l-21 20.66a.5.5 0 0 1-.7 0l-3.83-3.75a.5.5 0 0 1 0-.71L36.99 21.86a.5.5 0 0 0 0-.72L20.15 4.6a.5.5 0 0 1 0-.7z"
                  fill="#fff"
                />
                <path
                  d="M.15 3.9 3.98.14a.5.5 0 0 1 .7 0l21 20.65a1 1 0 0 1 0 1.4l-21 20.66a.5.5 0 0 1-.7 0L.15 39.1a.5.5 0 0 1 0-.71L16.99 21.86a.5.5 0 0 0 0-.72L.15 4.6a.5.5 0 0 1 0-.7z"
                  fill="#fff"
                />
              </svg>
            </Link>
          )}
        </div>

        <img src="/modak-assets/person2.png" className="modak-login-person" alt="" />
      </div>
    </ModakBackdrop>
  );
}

export default Login;
